/**
 * Slack for comparing playback time against step offsets. Seeking to a step
 * lands on a frame the browser can report a hair before the stored offset;
 * this stays under two frames so it never reaches into the next step.
 */
const STEP_OFFSET_TOLERANCE_SECONDS = 0.05;

/**
 * Whether playback at `currentTime` has reached a step starting at `offset`.
 *
 * @param offset - Step start in the recording, in seconds
 * @param currentTime - Current playback position, in seconds
 * @returns True once the step has started, allowing for seek rounding
 */
export function isStepReached(offset: number, currentTime: number): boolean {
  return offset <= currentTime + STEP_OFFSET_TOLERANCE_SECONDS;
}
